/**
 * Эмуляция бэкенда модуля «Визитка».
 *
 * На бэке по визиткам ничего не готово, поэтому все методы
 * methodsBusinessCard.js при API_READY === false проксируются сюда.
 * Состояние хранится в localStorage — сценарий «создал → сохранил →
 * перезагрузил страницу» работает так же, как будет работать с реальным API.
 *
 * Удалить весь файл вместе с ветками `if (!API_READY)`, когда бэк будет готов.
 */

const STORAGE_KEY = 'businessCardMock';
const MOCK_DELAY = 300;

// Каталог «других участников» — из него собираются запросы и коллекция
const MOCK_USERS = {
  101: {
    user: {
      id: 101,
      name: 'Петров Сергей Владимирович',
      photo: null,
      position: 'Директор по развитию',
      company: 'АО Технологии Будущего',
    },
    card_data: {
      fullName: 'Петров Сергей Владимирович',
      position: 'Директор по развитию',
      company: 'АО Технологии Будущего',
      phone: ['+79161234567', '+74951234567'],
      email: ['s.petrov@techfuture.ru'],
      website: ['techfuture.ru'],
      telegram: ['@s_petrov'],
      whatsapp: ['+79161234567'],
    },
  },
  102: {
    user: {
      id: 102,
      name: 'Кузнецова Анна Михайловна',
      photo: null,
      position: 'Руководитель отдела маркетинга',
      company: 'ГК Инновация',
    },
    card_data: {
      fullName: 'Кузнецова Анна Михайловна',
      position: 'Руководитель отдела маркетинга',
      company: 'ГК Инновация',
      phone: ['+79031234567'],
      email: ['a.kuznetsova@innov.ru'],
      website: [],
      telegram: [],
      whatsapp: ['+79031234567'],
    },
  },
  103: {
    user: {
      id: 103,
      name: 'Смирнов Дмитрий Олегович',
      photo: null,
      position: 'Технический директор',
      company: 'ООО ДигиталСофт',
    },
    card_data: {
      fullName: 'Смирнов Дмитрий Олегович',
      position: 'Технический директор',
      company: 'ООО ДигиталСофт',
      phone: [],
      email: ['d.smirnov@digitalsoft.ru'],
      website: ['digitalsoft.ru'],
      telegram: ['@dsmirnov'],
      whatsapp: [],
    },
  },
  104: {
    user: {
      id: 104,
      name: 'Орлова Ирина Сергеевна',
      photo: null,
      position: 'Менеджер по продажам',
      company: 'ЗАО Торговый Дом',
    },
    card_data: {
      fullName: 'Орлова Ирина Сергеевна',
      position: 'Менеджер по продажам',
      company: 'ЗАО Торговый Дом',
      phone: ['+79251234567'],
      email: [],
      website: [],
      telegram: [],
      whatsapp: [],
    },
  },
  201: {
    user: {
      id: 201,
      name: 'Захаров Алексей Петрович',
      photo: null,
      position: 'Главный инженер',
      company: 'ПАО Стройпроект',
    },
    card_data: {
      fullName: 'Захаров Алексей Петрович',
      position: 'Главный инженер',
      company: 'ПАО Стройпроект',
      phone: ['+79119876543'],
      email: ['a.zaharov@stroyproekt.ru'],
      website: [],
      telegram: ['@zaharov_a'],
      whatsapp: [],
    },
  },
  202: {
    user: {
      id: 202,
      name: 'Волкова Наталья Игоревна',
      photo: null,
      position: 'HR-директор',
      company: 'ООО Кадровый Резерв',
    },
    card_data: {
      fullName: 'Волкова Наталья Игоревна',
      position: 'HR-директор',
      company: 'ООО Кадровый Резерв',
      phone: ['+79052223344'],
      email: ['n.volkova@kadry.ru'],
      website: ['kadry.ru'],
      telegram: [],
      whatsapp: [],
    },
  },
  203: {
    user: {
      id: 203,
      name: 'Белов Константин Юрьевич',
      photo: null,
      position: 'Аналитик',
      company: 'ООО ДатаЛаб',
    },
    card_data: {
      fullName: 'Белов Константин Юрьевич',
      position: 'Аналитик',
      company: 'ООО ДатаЛаб',
      phone: [],
      email: ['k.belov@datalab.ru'],
      website: [],
      telegram: ['@kbelov'],
      whatsapp: [],
    },
  },
  205: {
    user: {
      id: 205,
      name: 'Морозова Ольга Дмитриевна',
      photo: null,
      position: 'Product Owner',
      company: 'АО Сервис Плюс',
    },
    card_data: {
      fullName: 'Морозова Ольга Дмитриевна',
      position: 'Product Owner',
      company: 'АО Сервис Плюс',
      phone: ['+79267778899'],
      email: ['o.morozova@serviceplus.ru'],
      website: [],
      telegram: ['@o_morozova'],
      whatsapp: ['+79267778899'],
    },
  },
};

const EMPTY_CARD = {
  fullName: '',
  position: '',
  department: '',
  company: '',
  phone: [],
  email: [],
  website: [],
  telegram: [],
  whatsapp: [],
};

function initialState() {
  return {
    // своя визитка ещё не создана — первый вход всегда ведёт на форму
    card: { is_created: false, data: { ...EMPTY_CARD } },
    collection: [
      { user_id: 101, exchanged_at: '2026-05-15T10:30:00Z' },
      { user_id: 102, exchanged_at: '2026-05-14T14:00:00Z' },
      { user_id: 103, exchanged_at: '2026-05-13T09:15:00Z' },
      { user_id: 104, exchanged_at: '2026-05-12T16:45:00Z' },
    ],
    requests: [
      {
        request_id: 1,
        user_id: 201,
        direction: 'incoming',
        status: 'pending',
        created_at: '2026-05-17T09:00:00Z',
      },
      {
        request_id: 2,
        user_id: 205,
        direction: 'incoming',
        status: 'pending',
        created_at: '2026-05-16T17:00:00Z',
      },
      {
        request_id: 3,
        user_id: 202,
        direction: 'outgoing',
        status: 'pending',
        created_at: '2026-05-16T14:30:00Z',
      },
      {
        request_id: 4,
        user_id: 203,
        direction: 'incoming',
        status: 'declined',
        created_at: '2026-05-14T11:00:00Z',
      },
      {
        request_id: 5,
        user_id: 204,
        direction: 'outgoing',
        status: 'declined',
        created_at: '2026-05-13T16:00:00Z',
      },
    ],
    lastRequestId: 5,
  };
}

let state = null;

function save() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.warn('[mock business-card] не удалось сохранить состояние', e);
  }
}

function load() {
  if (state) return state;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    if (parsed && parsed.card && Array.isArray(parsed.collection)) {
      state = parsed;
      return state;
    }
  } catch (e) {
    console.warn('[mock business-card] битое состояние, сбрасываю', e);
  }
  state = initialState();
  save();
  return state;
}

function clone(data) {
  return JSON.parse(JSON.stringify(data));
}

// Ответ API: в компонент уходит уже содержимое results (см. baseAxios .then)
function respond(data) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(clone(data)), MOCK_DELAY);
  });
}

// Ошибка в формате axios — чтобы компоненты обрабатывали её так же, как реальную
function fail(status, message) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const error = new Error(message || `Mock error ${status}`);
      error.response = { status, data: { results: { message } } };
      reject(error);
    }, MOCK_DELAY);
  });
}

// Профиль участника + его визитка; для неизвестного id генерируем заглушку
function userEntry(userId) {
  const id = Number(userId);
  if (MOCK_USERS[id]) return MOCK_USERS[id];
  return {
    user: {
      id, name: `Участник №${id}`, photo: null, position: '', company: '',
    },
    card_data: { ...EMPTY_CARD, fullName: `Участник №${id}` },
  };
}

// Элемент списка: визитки в нём нет — только профиль. card_data приезжает
// отдельным запросом, когда карточку открывают, см. collectionCard().
function collectionItem(row) {
  const entry = userEntry(row.user_id);
  return {
    user: entry.user,
    exchanged_at: row.exchanged_at,
  };
}

// Одиночная визитка по /collection/{userId} — единственное место с card_data.
function collectionCard(row) {
  const entry = userEntry(row.user_id);
  return {
    user: entry.user,
    card_data: entry.card_data,
    exchanged_at: row.exchanged_at,
  };
}

function requestItem(row) {
  const entry = userEntry(row.user_id);
  return {
    request_id: row.request_id,
    direction: row.direction,
    status: row.status,
    user: { id: entry.user.id, name: entry.user.name },
    created_at: row.created_at,
  };
}

const mockApi = {
  // GET /business-card
  getMyBusinessCard() {
    return respond(load().card);
  },

  // PUT /business-card
  saveBusinessCard(formData) {
    const s = load();
    s.card = { is_created: true, data: clone(formData) };
    save();
    return respond(s.card);
  },

  // DELETE /business-card
  deleteBusinessCard() {
    const s = load();
    s.card = { is_created: false, data: { ...EMPTY_CARD } };
    save();
    return respond({ message: 'ok' });
  },

  // GET /business-card/request
  getBusinessCardRequests(direction, status) {
    let rows = load().requests;
    if (direction) rows = rows.filter((r) => r.direction === direction);
    if (status) rows = rows.filter((r) => r.status === status);
    return respond({ items: rows.map(requestItem) });
  },

  // POST /business-card/request
  sendBusinessCardRequest(toUserId) {
    const s = load();
    const id = Number(toUserId);
    const exists = s.requests.some((r) => r.user_id === id && r.status === 'pending');
    if (exists) return fail(409, 'Запрос уже отправлен');
    s.lastRequestId += 1;
    s.requests.push({
      request_id: s.lastRequestId,
      user_id: id,
      direction: 'outgoing',
      status: 'pending',
      created_at: new Date().toISOString(),
    });
    save();
    return respond({ request_id: s.lastRequestId, status: 'pending' });
  },

  // POST /business-card/request/{id}/accept — визитка уезжает в коллекцию
  acceptBusinessCardRequest(requestId) {
    const s = load();
    const row = s.requests.find((r) => r.request_id === Number(requestId));
    if (!row) return fail(404, 'Запрос не найден');
    s.requests = s.requests.filter((r) => r.request_id !== row.request_id);
    if (!s.collection.some((c) => c.user_id === row.user_id)) {
      s.collection.unshift({ user_id: row.user_id, exchanged_at: new Date().toISOString() });
    }
    save();
    return respond({ message: 'ok' });
  },

  // POST /business-card/request/{id}/decline — уходит в «Отклонённые»
  declineBusinessCardRequest(requestId) {
    const s = load();
    const row = s.requests.find((r) => r.request_id === Number(requestId));
    if (!row) return fail(404, 'Запрос не найден');
    row.status = 'declined';
    save();
    return respond({ message: 'ok' });
  },

  // DELETE /business-card/request/{id} — отзыв своего запроса
  revokeBusinessCardRequest(requestId) {
    const s = load();
    const row = s.requests.find((r) => r.request_id === Number(requestId));
    if (!row) return fail(404, 'Запрос не найден');
    s.requests = s.requests.filter((r) => r.request_id !== row.request_id);
    save();
    return respond({ message: 'ok' });
  },

  // GET /business-card/collection
  getBusinessCardCollection() {
    return respond({ items: load().collection.map(collectionItem) });
  },

  // GET /business-card/collection/{userId}
  getBusinessCardCollectionItem(userId) {
    const row = load().collection.find((c) => c.user_id === Number(userId));
    if (!row) return fail(404, 'Визитка не найдена');
    return respond(collectionCard(row));
  },

  // DELETE /business-card/collection/{userId}
  deleteFromCollection(userId) {
    const s = load();
    const id = Number(userId);
    if (!s.collection.some((c) => c.user_id === id)) return fail(404, 'Визитка не найдена');
    s.collection = s.collection.filter((c) => c.user_id !== id);
    save();
    return respond({ message: 'ok' });
  },

  // GET /business-card/status/{userId}
  getBusinessCardStatus(userId) {
    const s = load();
    const id = Number(userId);
    if (s.collection.some((c) => c.user_id === id)) {
      return respond({ exchange_status: 'exchanged' });
    }
    const row = s.requests.find((r) => r.user_id === id && r.status === 'pending');
    if (row) {
      return respond({
        exchange_status: row.direction === 'outgoing' ? 'pending_outgoing' : 'pending_incoming',
        request_id: row.request_id,
      });
    }
    return respond({ exchange_status: 'none' });
  },

  // Сброс эмуляции к начальному состоянию (вызывается из консоли)
  reset() {
    state = initialState();
    save();
    return clone(state);
  },

  // Текущее состояние — для отладки из консоли
  dump() {
    return clone(load());
  },
};

// В dev доступно из консоли: businessCardMock.reset() / businessCardMock.dump()
if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  window.businessCardMock = mockApi;
}

export default mockApi;
